package one.healthium.insights.ui.components.items

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material3.Icon
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import one.healthium.insights.domain.models.ActionModel
import one.healthium.insights.domain.models.ContentEntry
import one.healthium.insights.ui.utils.resolve
import one.healthium.ui.compose.components.AppIcons
import one.healthium.ui.compose.theme.AppTheme
import one.healthium.ui.compose.theme.black10
import one.healthium.ui.compose.theme.black50
import org.jetbrains.compose.resources.painterResource

@Composable
fun ShoppingListItem(
    item: ContentEntry.ShoppingList,
    onClick: (ActionModel) -> Unit,
) {
    Row(
        modifier = Modifier
            .padding(12.dp)
            .fillMaxWidth()
            .background(item.color?.resolve() ?: AppTheme.colors.surface, AppTheme.shapes.medium)
            .clip(AppTheme.shapes.medium)
            .clickable { onClick(item.action) }
            .padding(horizontal = 12.dp, vertical = 9.dp),
        verticalAlignment = Alignment.CenterVertically,
    ) {
        Box(
            modifier = Modifier
                .size(36.dp)
                .background(black10, CircleShape),
            contentAlignment = Alignment.Center,
        ) {
            Icon(
                painter = painterResource(AppIcons.icCart),
                tint = black50,
                contentDescription = null,
            )
        }
        Spacer(Modifier.width(12.dp))
        Text(
            text = item.name,
            style = AppTheme.textStyles.secondary_17_500,
            color = AppTheme.colors.text100,
            maxLines = 1,
            overflow = TextOverflow.Ellipsis,
        )
        Spacer(Modifier.width(8.dp))
        Spacer(Modifier.weight(1f))
        Image(
            painter = painterResource(AppIcons.icArrowRight),
            contentDescription = null,
        )
    }
}